<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-on:click="onDownload()">
        {{ $t('Download CF2') }}
    </button>    
</div>

